import {
  GET_JOURNAL_LEDGER_REQUEST,
  GET_JOURNAL_LEDGER_SUCCESS,
  GET_JOURNAL_LEDGER_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getJournalLedger = (token, data) => (dispatch) => {
  dispatch({ type: GET_JOURNAL_LEDGER_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/journalLedger`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      account_id: data.account_id === undefined || data.account_id === "All" ? null : data.account_id,
      from_date: moment(data.from_date).format("MM-DD-YYYY"),
      to_date: moment(data.to_date).format("MM-DD-YYYY"),
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_JOURNAL_LEDGER_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_JOURNAL_LEDGER_ERROR,
        payload: [],
      });
    });
};